import { render } from "./LicenseTag.vue?vue&type=template&id=0766c99b&ts=true"
import script from "./LicenseTag.vue?vue&type=script&lang=ts"
export * from "./LicenseTag.vue?vue&type=script&lang=ts"

import "./LicenseTag.vue?vue&type=style&index=0&id=0766c99b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__